export const OPERATION_ROTATE = 'Rotate';
export const OPERATION_FLIP = 'Flip';